import React, { useEffect, useState, useMemo } from 'react';
import moment from 'moment';
import 'font-awesome/css/font-awesome.min.css';
import './CityOfEvanston.styl';
import JustParkLogo from './justpark-logo.svg';

const urlBase = 'https://insights.justpark.com/api';
const token = 'a0OrkKhPK3vRtDFCLnbCibc7G5_LHSgU2V-4jufR';
const isIos = () => (
    (navigator.platform.indexOf('iPhone') !== -1)
    || (navigator.platform.indexOf('iPod') !== -1)
    || (navigator.platform.indexOf('iPad') !== -1)
);
// `href` starting with `maps://` will open the location in Apple Map
const getHref = (url) => (isIos() ? `maps://${url}` : `https://${url}`);
const formatNumber = (n) => (Number.isNaN(n) ? 'N/A' : n);
const fetchParams = {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
    mode: 'cors'
};
const GREY = 'grey';
const RED = '#ff0000';
const YELLOW = '#fff000';
const GREEN = '#00b050';
const mapUrl1800Maple = 'maps.google.com/maps/place/1800+Maple+Self+Park/@42.0500985,-87.6876284,17z/data=!3m1!4b1!4m5!3m4!1s0x880fd0092cda8aaf:0x51cbbf16db9f6a08!8m2!3d42.0500945!4d-87.6854397';
const mapUrlChurchStreet = 'maps.google.com/maps/place/1800+Maple+Self+Park/@42.0500985,-87.6876284,17z/data=!3m1!4b1!4m5!3m4!1s0x880fd0092cda8aaf:0x51cbbf16db9f6a08!8m2!3d42.0500945!4d-87.6854397';
const mapUrlLot10 = 'maps.google.com/maps/place/Evanston+Public+Library/@42.0484186,-87.6823259,17z/data=!3m1!4b1!4m5!3m4!1s0x880fd00c5eb8f009:0xf3a0e36e400733c!8m2!3d42.0484146!4d-87.6801372';
const mapUrlLot21 = 'maps.google.com/maps/place/1100+Central+St,+Evanston,+IL+60201/@42.0642134,-87.6890267,17z/data=!3m1!4b1!4m5!3m4!1s0x880fdaa545570d3f:0x9fe27e4cecb8aa60!8m2!3d42.0642134!4d-87.686838';
const mapUrlLot24 = 'maps.google.com/maps/place/727+Main+St,+Evanston,+IL+60202/@42.0339936,-87.6838422,17z/data=!3m1!4b1!4m5!3m4!1s0x880fd03e3fd5a991:0xca2fa51069e0aa30!8m2!3d42.0339896!4d-87.6816535';
const mapUrlLot25 = 'maps.google.com/maps/place/1612+Maple+Ave,+Evanston,+IL+60201/@42.0475374,-87.6874403,17z/data=!3m1!4b1!4m5!3m4!1s0x880fd00e55d2022b:0xca65a49f5d019ab9!8m2!3d42.0475334!4d-87.6852516';
const mapUrlLot27 = 'maps.google.com/maps/place/1621+Oak+Ave,+Evanston,+IL+60201/@42.0479986,-87.688665,17z/data=!3m1!4b1!4m5!3m4!1s0x880fd00f734be34b:0xf02c0b13ae6ddd2d!8m2!3d42.0479946!4d-87.6864763';
const mapUrlLot3 = 'maps.google.com/maps/place/1700+Chicago+Ave,+Evanston,+IL+60201/@42.0477318,-87.681105,17z/data=!3m1!4b1!4m5!3m4!1s0x880fd00cc7f6f7f7:0x5c415068b45241f6!8m2!3d42.0477278!4d-87.6789163';
const mapUrlLot4 = 'maps.google.com/maps/place/2100+Central+St,+Evanston,+IL+60201/@42.064108,-87.704389,17z/data=!3m1!4b1!4m5!3m4!1s0x880fc5521edf1955:0x578377638c6b3ff9!8m2!3d42.064104!4d-87.7022003';
const mapUrlLot54 = 'maps.google.com/maps/place/2500+Poplar+Ave,+Evanston,+IL+60201/@42.0628774,-87.6990882,17z/data=!3m1!4b1!4m5!3m4!1s0x880fdaacdf532fd5:0xfd94aaaccf214c4b!8m2!3d42.0628734!4d-87.6968995';
const mapUrlLot60 = 'maps.google.com/maps/place/1200+Chicago+Ave,+Evanston,+IL+60202/@42.0399145,-87.6830688,17z/data=!3m1!4b1!4m5!3m4!1s0x880fd0147f69c70d:0x30819af906accaa!8m2!3d42.0399105!4d-87.6808801';
const mapUrlSermanPlaza = 'maps.google.com/maps/place/Sherman+Plaza+Parking+Garage/@42.0476084,-87.6851104,17z/data=!3m1!4b1!4m5!3m4!1s0x880e2cb9d6798817:0x329737cf1f11ef7e!8m2!3d42.0476044!4d-87.6829217';
const occupancyToColor = (percentage) => {
    if (Number.isNaN(percentage)) return GREY;
    if (percentage >= 85) return RED;
    if (percentage >= 50) return YELLOW;
    return GREEN;
};
const centralZoneLocationIds = [322367, 356935, 133081];
const mainDempsterZoneLocationIds = [721274, 358185];
const downtownZoneLocationIds = [104833, 162756, 573430, 375342];
const locationUrl = (locationId) => (`${urlBase}/users/v1/garages/id/${locationId}`);
const locationHisotricalOccupancyUrl = (locationId) => (`${urlBase}/ds/v3/garages/${locationId}/past/occupancy`);
const locationRealTimeOccupancyUrl = (locationId) => (`${urlBase}/ds/v3/garages/${locationId}/current/occupancy`);
const sumAllGroups = (groups = []) => groups.map(({ value }) => value).reduce((acc, curr) => acc + curr, 0);
const RealtimeOccupancy = ({ locationId }) => {
    const [occupancyData, setOccupancyData] = useState([]);
    const [isFetching, setIsFetching] = useState(true);
    const [error, setError] = useState();
    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsFetching(true);
                const [occupancy, metadata] = await Promise.all([
                    fetch(locationRealTimeOccupancyUrl(locationId), fetchParams).then((res) => res.json()),
                    fetch(locationUrl(locationId), fetchParams).then((res) => res.json()),
                ]);
                const totalOccupancy = sumAllGroups(occupancy.value);
                const capacity = metadata.spaces || NaN;
                setOccupancyData([totalOccupancy, capacity]);
            } catch (err) {
                setError(err);
            } finally {
                setIsFetching(false);
            }
        };
        if (locationId) fetchData();
    }, [locationId]);
    if (isFetching) {
        return (
            <div className="occupancy-container">
                <span>
                    <i className="fa fa-fw fa-spinner fa-spin" />
                </span>
            </div>
        );
    }
    if (error) {
        return (
            <div className="occupancy-container" style={{ backgroundColor: GREY }}>
                <span>
                    <i className="fa fa-fw fa-exclamation-triangle" />
                </span>
                <p>Try again later</p>
            </div>
        );
    }
    const [occupancy = NaN, capacity = NaN] = occupancyData;
    const spacesAvaliable = capacity - occupancy;
    const percentageOccupied = 100 * (occupancy / capacity);
    return (
        <div className="occupancy-container" style={{ backgroundColor: occupancyToColor(percentageOccupied) }}>
            <span className="occupancy-metric">{formatNumber(spacesAvaliable)}</span>
            <p>spots available</p>
        </div>
    );
};
const PredictedOccupancy = ({ locationIds = [] }) => {
    const [occupancyData, setOccupancyData] = useState([]);
    const [isFetching, setIsFetching] = useState(true);
    const [error, setError] = useState();
    const dateLastWeek = useMemo(() => moment().subtract(1, 'week').format('YYYY-MM-DD'), []);
    const currentHour = useMemo(() => moment().hour(), []);
    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsFetching(true);
                const metadataPromises = locationIds
                    .map(locationUrl)
                    .map((url) => fetch(url, fetchParams).then((res) => res.json()));
                const occupancyPromises = locationIds
                    .map(locationHisotricalOccupancyUrl)
                    .map((url) => `${url}/from/${dateLastWeek}/24/1h`)
                    .map((url) => fetch(url, fetchParams).then((res) => res.json()));
                const [occupancies, metadatas] = await Promise.all([
                    Promise.all(occupancyPromises),
                    Promise.all(metadataPromises),
                ]);
                const totalOccupancy = occupancies
                    .map((data) => data?.value || [])
                    .map((groups) => groups.map(({ value }) => value[currentHour]))
                    .map((groupsCurrentHour) => groupsCurrentHour.reduce((acc, curr = 0) => acc + curr, 0))
                    .reduce((acc, curr) => acc + curr, 0);
                const totalCapacity = metadatas
                    .map((data) => data?.spaces || 0)
                    .reduce((acc, curr) => acc + curr, 0);
                setOccupancyData([totalOccupancy, totalCapacity]);
            } catch (err) {
                setError(err);
            } finally {
                setIsFetching(false);
            }
        };
        if (locationIds?.length) fetchData();
    }, [locationIds, dateLastWeek, currentHour]);
    if (isFetching) {
        return (
            <div className="occupancy-container">
                <span>
                    <i className="fa fa-fw fa-spinner fa-spin" />
                </span>
            </div>
        );
    }
    if (error) {
        return (
            <div className="occupancy-container" style={{ backgroundColor: GREY }}>
                <span>
                    <i className="fa fa-fw fa-exclamation-triangle" />
                </span>
                <p>Try again later</p>
            </div>
        );
    }
    const [occupancy = NaN, capacity = NaN] = occupancyData;
    const percentageOccupied = 100 * (occupancy / capacity);
    const percentageAvailable = 100 - percentageOccupied;
    return (
        <div className="occupancy-container" style={{ backgroundColor: occupancyToColor(percentageOccupied) }}>
            <span className="occupancy-metric">{formatNumber(Math.round(percentageAvailable))}%</span>
            <p>availability</p>
        </div>
    );
};

const CityOfEvanstonParkingWidget = () => (
    <div className="smk-city-of-evanston-widget">
        <div className="header">
            <h1>Real Time Parking Occupancy</h1>
            <a href="https://www.justpark.com" target="_blank" rel="noopener noreferrer">
                <span>Powered by</span>
                <img alt="JustPark" src={JustParkLogo} />
            </a>
        </div>
        <h2>Garages</h2>
        <div className="location-container">
            <div className="location">
                <h3>
                    <a href={getHref(mapUrl1800Maple)} target="_blank" rel="noopener noreferrer">1800 Maple</a>
                </h3>
                <RealtimeOccupancy
                    locationId={292744}
                />
            </div>
            <div className="location">
                <h3>
                    <a href={getHref(mapUrlChurchStreet)} target="_blank" rel="noopener noreferrer">Church Street</a>
                </h3>
                <RealtimeOccupancy
                    locationId={184215}
                />
            </div>
            <div className="location">
                <h3>
                    <a href={getHref(mapUrlSermanPlaza)} target="_blank" rel="noopener noreferrer">Sherman Plaza</a>
                </h3>
                <RealtimeOccupancy
                    locationId={835525}
                />
            </div>
        </div>
        <div className="header">
            <h1>Occupancy Availability Prediction</h1>
        </div>
        <h2>Lots</h2>
        <div className="location-container">
            <div className="location">
                <h3>
                    Central Zone
                    <sup>1</sup>
                </h3>
                <PredictedOccupancy
                    locationIds={centralZoneLocationIds}
                />
            </div>
            <div className="location">
                <h3>
                    Main/Dempster Zone
                    <sup>2</sup>
                </h3>
                <PredictedOccupancy
                    locationIds={mainDempsterZoneLocationIds}
                />
            </div>
            <div className="location">
                <h3>
                    Downtown Zone
                    <sup>3</sup>
                </h3>
                <PredictedOccupancy
                    locationIds={downtownZoneLocationIds}
                />
            </div>
        </div>
        <ol className="legend">
            <li>
                Central Zone includes:
                {' '}
                <a href={getHref(mapUrlLot4)} target="_blank" rel="noopener noreferrer">Lot 4</a>
                {', '}
                <a href={getHref(mapUrlLot21)} target="_blank" rel="noopener noreferrer">Lot 21</a>
                {', '}
                and
                {' '}
                <a href={getHref(mapUrlLot54)} target="_blank" rel="noopener noreferrer">Lot 54</a>
            </li>
            <li>
                Main/Dempster Zone Inlcudes:
                {' '}
                <a href={getHref(mapUrlLot24)} target="_blank" rel="noopener noreferrer">Lot 24</a>
                {' '}
                and
                {' '}
                <a href={getHref(mapUrlLot60)} target="_blank" rel="noopener noreferrer">Lot 60</a>
            </li>
            <li>
                Downtown Zone includes:
                {' '}
                <a href={getHref(mapUrlLot3)} target="_blank" rel="noopener noreferrer">Lot 3</a>
                {', '}
                <a href={getHref(mapUrlLot10)} target="_blank" rel="noopener noreferrer">Lot 10</a>
                {', '}
                <a href={getHref(mapUrlLot25)} target="_blank" rel="noopener noreferrer">Lot 25</a>
                {', '}
                and
                {' '}
                <a href={getHref(mapUrlLot27)} target="_blank" rel="noopener noreferrer">Lot 27</a>
            </li>
        </ol>
    </div>
);

export default CityOfEvanstonParkingWidget;
